import React from 'react';
import { ArrowRightWhiteIcon } from './icons';

interface SignupRequiredModalProps {
    isOpen: boolean;
    onClose: () => void;
    onLogin: () => void;
    onSignup: () => void;
}

export const SignupRequiredModal: React.FC<SignupRequiredModalProps> = ({
    isOpen,
    onClose,
    onLogin,
    onSignup
}) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6 relative">
                {/* Close button */}
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 w-8 h-8 rounded-full hover:bg-gray-100 flex items-center justify-center transition-colors"
                >
                    <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>

                {/* Content */}
                <div className="text-center">
                    {/* Icon */}
                    <div className="mx-auto w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mb-4">
                        <svg className="w-8 h-8 text-primary-og-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-1a2 2 0 00-2-2H6a2 2 0 00-2 2v1a2 2 0 002 2zM12 7a4 4 0 100 8 4 4 0 000-8z" />
                        </svg>
                    </div>

                    {/* Title */}
                    <h2 className="text-2xl font-grotesk font-semibold text-grayscale-1300 mb-2">
                        Sign up to view complete results
                    </h2>

                    {/* Description */}
                    <p className="text-grayscale-1000 font-grotesk text-sm mb-6 leading-relaxed">
                        To access full technology details, researcher profiles, and university contact information, please create an account or sign in.
                    </p>

                    {/* Action buttons */}
                    <div className="flex flex-col sm:flex-row gap-3">
                        <button
                            onClick={() => {
                                onClose();
                                onSignup();
                            }}
                            className="flex-1 flex items-center justify-center gap-2 py-3 px-4 bg-primary-og-600 text-white font-grotesk font-medium text-sm rounded-full hover:bg-primary-700 transition-colors shadow-lg"
                        >
                            Sign Up
                            <ArrowRightWhiteIcon />
                        </button>
                        <button
                            onClick={() => {
                                onClose();
                                onLogin();
                            }}
                            className="flex-1 py-3 px-4 border border-primary-300 text-grayscale-1300 font-grotesk font-medium text-sm rounded-full hover:bg-gray-50 transition-colors"
                        >
                            Sign In
                        </button>
                    </div>

                    {/* Additional info */}
                    <p className="text-xs text-grayscale-900 mt-4 font-grotesk">
                        Already have an account? <button onClick={() => { onClose(); onLogin(); }} className="text-primary-og-600 font-medium underline">Sign in here</button>
                    </p>
                </div>
            </div>
        </div>
    );
};
